import { render, staticRenderFns } from "./PhrasebookPage.vue?vue&type=template&id=f7121b56&scoped=true"
import script from "./PhrasebookPage.vue?vue&type=script&lang=js"
export * from "./PhrasebookPage.vue?vue&type=script&lang=js"
import style0 from "./PhrasebookPage.vue?vue&type=style&index=0&id=f7121b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7121b56",
  null
  
)

export default component.exports